import { render } from "./VabeneCampagneList.vue?vue&type=template&id=e7837048&ts=true"
import script from "./VabeneCampagneList.vue?vue&type=script&lang=ts"
export * from "./VabeneCampagneList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__